import { useLazyQuery, useQuery } from "@apollo/client/react";import React, { useEffect, useState } from "react";
import { Typography } from "@mui/material";
import { Grid } from '@mui/material';

import DataGridGenerico from "../../../../../components/dataGrid/DataGridGenerico";
import { useTabDocumentacionRI } from "../../hooks/TabDocumentacion/useTabDocumentacionRI";
import GET_DOCUMENTOS_RI, { adaptDocumentosArray } from "../../../../../data/graphQL/queries/GestionAsistencial/getDocumentosRIAsistencial";
import DocumentViewer from '../../../../../components/DocumentViewer';
import GET_DOCUMENTOS_VISITAS_MEDICO, { adaptDocumentosVisitasMedicoArray } from "../../../../../data/graphQL/queries/GestionAsistencial/getDocumentosVisitasMedico";
import toast from "react-hot-toast";
import { useTabDocumentacionVisitasMedicos } from "../../hooks/TabDocumentacion/useTabDocumentacionVisitasMedicos";
import { ResumenIngresoPrint } from "../../../../ResumenIngresoDetalle/components/ResumenIngresoPrint";
import { useHtmlRIFetcher } from "../../../../../hooks/useHtmlRIFetcher";

export function TabDocumentacionRI({
  evaluacionSelected
}) {
  const { idEvaluacion } = evaluacionSelected;
  const [ri, setRI] = useState([]);
  const { fetchHtml, HtmlRenderer } = useHtmlRIFetcher(ResumenIngresoPrint);
  const { columns, fileToView, resetFileToView } = useTabDocumentacionRI({ ri, fetchHtml });
  const [visitasMedicos, setVisitasMedicos] = useState([]);
  const { columnsVisita, fileToViewVisita, resetFileToViewVisita } = useTabDocumentacionVisitasMedicos(visitasMedicos);

  const { data: dataDocumentosRI } = useQuery(GET_DOCUMENTOS_RI, {
    variables: {
      idEvaluacion: idEvaluacion
    }
  });

  useEffect(() => {
    if (!dataDocumentosRI) return;
    setRI(adaptDocumentosArray(dataDocumentosRI));
  }, [dataDocumentosRI]);


  useEffect(() => {
    if (!loadingVisitas)
    getVisitasMedicos({ variables: { idEvaluacion: idEvaluacion } });
  }, [idEvaluacion]);

  const [getVisitasMedicos, { data: dataVisitasMedicos, loading: loadingVisitas }] = useLazyQuery(GET_DOCUMENTOS_VISITAS_MEDICO, {
    fetchPolicy: 'no-cache'
  });

  useEffect(() => {
    if (!dataVisitasMedicos) return;
    if (dataVisitasMedicos.visitasMedico.success) {
      setVisitasMedicos(adaptDocumentosVisitasMedicoArray(dataVisitasMedicos.visitasMedico.valorEsperado));
    } else {
      toast.error('Error al consultar las visitas de Médicos.');
    }
  }, [dataVisitasMedicos]);

  return (
    <div className='generic-tab-container' style={{ marginTop: "20px" }}>
      <Grid container spacing={3}>
        <Grid size={{ xs: 12 }}>
          <Typography sx={{ fontSize: "16px", fontWeight: "600", mb: "20px" }}>
            Resumen de ingreso
          </Typography>
          <DataGridGenerico
            columns={columns}
            rows={ri}
            totalCount={ri?.length || 0}
            toolbar={false} />
          
          <br />
          <Typography sx={{ fontSize: "16px", fontWeight: "600", mb: "20px" }}>
            Evoluciones
          </Typography>
          <DataGridGenerico
            columns={columnsVisita}
            rows={visitasMedicos}
            totalCount={visitasMedicos?.length || 0}
            toolbar={false}
            loading={loadingVisitas} />
          
        </Grid>
      </Grid>
      {fileToView && <DocumentViewer data={fileToView} setOpenDlg={resetFileToView} download={true} />}
      {fileToViewVisita && <DocumentViewer data={fileToViewVisita} setOpenDlg={resetFileToViewVisita} download={true} />}
      {HtmlRenderer}
    </div>);

}